import { render, staticRenderFns } from "./AssessmentPersonality.vue?vue&type=template&id=bbd5cf66&"
import script from "./AssessmentPersonality.vue?vue&type=script&lang=js&"
export * from "./AssessmentPersonality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports